import Vue      from "vue";
import App      from "./App.vue";
import store    from "./store";
import router   from "./router/router";
import vuetify  from "./plugins/vuetify";
// import "./plugins/vuetify-extra-components";

import i18n     from "./lang/lang.js";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader
import "material-design-icons-iconfont/dist/material-design-icons.css";

import moment from 'moment';
import VueMoment from 'vue-moment';
require('moment/locale/de-ch');
moment.locale('de-ch');
Vue.use(VueMoment, { moment });

//for DEV
import TreeView from "vue-json-tree-view";
Vue.use(TreeView);


import VueCurrencyInput from 'vue-currency-input';
const pluginOptions = {
  /* see config reference */
  globalOptions: { currency: 'CHF'}
}
Vue.use(VueCurrencyInput, pluginOptions);

import FlagIcon from 'vue-flag-icon';
Vue.use(FlagIcon);

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    moment,
    render: h => h(App)
}).$mount("#app");
